<script lang="ts">
	import SeparatorIcon from '$lib/assets/svg/icons/chevron-right.svg?component';
	import type { Breadcrumb } from '$lib/types';

	interface Props {
		items?: Breadcrumb[];
	}

	let { items = [] }: Props = $props();
</script>

<nav class="Breadcrumbs" aria-label="Breadcrumbs">
	<ul class="Breadcrumbs__list">
		{#each items as { url, label }, index (label)}
			{@const isLast = index === items.length - 1}
			<li class="Breadcrumbs__item">
				<a
					class="Breadcrumbs__link"
					class:Breadcrumbs__link--current={isLast}
					href={url}
					aria-current={isLast ? 'page' : null}
				>
					{label}
				</a>
				{#if !isLast}
					<span class="Breadcrumbs__icon">
						<SeparatorIcon aria-hidden="true"></SeparatorIcon>
					</span>
				{/if}
			</li>
		{/each}
	</ul>
</nav>

<style lang="scss" src="./Breadcrumbs.scss"></style>
